import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem, 
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import UnitInputs from '../../components/UnitInputs/UnitInputs';
import { connect } from 'react-redux';
import { updateUnitRequestAction } from '../../store/unit/unitActions';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateUnit = ({ updateUnitRequest, isLoading, updateUnitData, unitList }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();
  const unitFromList = unitList?.find(u => u.UnitId?.toString() === id);
  const unitData = location.state?.unit || unitFromList || null;

  const handleSubmit = (data) => {
    updateUnitRequest({ data: { ...data, unitId: id }, navigate });
  };

  const handleCancel = () => {
    navigate('/unit');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/unit" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('units')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateUnit')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateUnit')}</h4>
              {unitData?.UnitId && (
                <small className="text-muted">ID: {unitData.UnitId}</small>
              )}
            </CCardHeader>
            <CCardBody>
              {unitData ? (
                <UnitInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateUnitData}
                  initialData={unitData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center">
                  <p>{t('noDataFound')}</p>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateUnitData: state.unitReducer.updateUnitData,
  unitList: state.unitReducer.unitList,
});

const mapDispatchToProps = (dispatch) => ({
  updateUnitRequest: (payload) => dispatch(updateUnitRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUnit);
